import script from "./MenuPict.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPict.vue?vue&type=script&setup=true&lang=js"

import "./MenuPict.vue?vue&type=style&index=0&id=4ecbfe80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecbfe80"]])

export default __exports__